import axios from "axios";
import { API_ENDPOINT_BASE_URL } from "./constants";

export const callAPi = async (api, method, params) => {
  let url = api;
  if (!api.includes("://")) {
    url = API_ENDPOINT_BASE_URL + api;
  }

  try {
    if (method === "POST") {
      const response = await axios.post(url, params, {});
      if (response.status === 200) {
        return { status: 200, data: response.data };
      } else {
        return { status: response.status };
      }
    }

    if (method === "PUT") {
      const response = await axios.put(url, params, {});
      if (response.status === 200) {
        return { status: 200, data: response.data };
      } else {
        return { status: response.status };
      }
    }

    if (method === "OPTIONS") {
      const response = await axios.options(url, params, {});
      if (response.status === 200) {
        return { status: 200, data: response.data };
      } else {
        return { status: response.status };
      }
    }

    if (method === "GET") {
      const response = await axios.get(url, { params: params });
      if (response.status === 200) {
        return { status: 200, data: response.data };
      } else {
        return { status: response.status };
      }
    }

    if (method === "DELETE") {
      const response = await axios.delete(url);
      if (response.status === 200) {
        return { status: 200, data: response.data };
      } else {
        return { status: response.status };
      }
    }
  } catch (error) {
    console.error(error);
    const response2 = { status: 504, response: error.response };
    if (error.response) {
      response2.status = error.response.status;
      response2.data = error.response.data;
    }
    return response2;
  }
};
